/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { BehaviorSubject ,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Tab } from '../../core/model/tab.model';

/**
 * @export
 * @class LmsModuleService
 */
@Injectable()
export class LmsModuleService {

    selectedTab: Observable<Tab>;

    newTab: Observable<Tab>;

    deleteTab: Observable<Tab>;

    private deleteTabBS: BehaviorSubject<Tab>;

    private selectedTabBS: BehaviorSubject<Tab>;

    private newTabBS: BehaviorSubject<Tab>;

    /**
     * Creates an instance of LmsModuleService.
     * @memberOf LmsModuleService
     */
    constructor() {
        this.selectedTabBS = <BehaviorSubject<Tab>>new BehaviorSubject({});
        this.selectedTab = this.selectedTabBS.asObservable();

        this.newTabBS = <BehaviorSubject<Tab>>new BehaviorSubject({});
        this.newTab = this.newTabBS.asObservable();

        this.deleteTabBS = <BehaviorSubject<Tab>>new BehaviorSubject({});
        this.deleteTab = this.deleteTabBS.asObservable();
    }

    /**
     * This is used to update Tab
     * @param {Tab} tab
     * @memberOf LmsModuleService
     */
    updateSelectedTab(tab: Tab) {
        this.selectedTabBS.next(tab);
    }

    /**
     * This is used to add new Tab
     * @param {Tab} tab
     * @memberOf LmsModuleService
     */
    addTab(tab: Tab) {
        this.newTabBS.next(tab);
    }

    /**
     * This is used to remove Tab
     * @param {Tab} tab
     * @memberOf LmsModuleService
     */
    removeTab(tab: Tab) {
        this.deleteTabBS.next(tab);
    }

}
